export { MaterialIcon } from '@hyphengroup/cms-components/components/MaterialIcon';
